import { ApplicationRef, Injectable } from '@angular/core';
import { SwUpdate } from '@angular/service-worker';
import { concat, interval } from 'rxjs';
import { first } from 'rxjs/operators';

@Injectable({providedIn: 'root'})
export class CheckUpdateService {

  constructor(appRef: ApplicationRef, updates: SwUpdate) {
    // console.log('DS Scout----- starting SW CheckforUpdate');
    // Allow the app to stabilize first, before starting
    // polling for updates with `interval()`.
    const appIsStable$ = appRef.isStable.pipe(first(isStable => isStable === true));
    //const everySixHours$ = interval(6 * 60 * 60 * 1000);
    const everySixHours$ = interval(60 * 1000);
    const everySixHoursOnceAppIsStable$ = concat(appIsStable$, everySixHours$);

    everySixHoursOnceAppIsStable$.subscribe(async () => {
      try {
        // console.log('DS Scout----- CheckforUpdate: checking for updates');
        const updateFound = await updates.checkForUpdate();
        // console.log(updateFound ? 'A new version is available.' : 'Already on the latest version.');
        if(updateFound)
          window.location.reload();
      } catch (err) {
        // console.error('Failed to check for updates:', err);
      }
    });
  }
}
